import React from "react";
import { Box, HStack, Icon, VStack } from "@chakra-ui/react";
import { FiAlertCircle, FiAlertTriangle, FiCheckCircle, FiInfo } from "react-icons/fi";
import { Text14 } from "design-system/primitives/TextSizes";

export type CalloutVariant = "info" | "warning" | "danger" | "success";

export interface CalloutProps {
  variant?: CalloutVariant;
  title?: string;
  children: React.ReactNode;
}

const variantStyles: Record<CalloutVariant, { bg: string; border: string; iconColor: string; icon: typeof FiInfo }> = {
  info: { bg: "cdsIndigo.50", border: "cdsIndigo.400", iconColor: "cdsIndigo.500", icon: FiInfo },
  warning: { bg: "yellow.50", border: "yellow.400", iconColor: "yellow.600", icon: FiAlertTriangle },
  danger: { bg: "red.50", border: "red.400", iconColor: "red.500", icon: FiAlertCircle },
  success: { bg: "green.50", border: "green.400", iconColor: "green.600", icon: FiCheckCircle },
};

export function Callout({ variant = "info", title, children }: CalloutProps) {
  const styles = variantStyles[variant];

  return (
    <Box
      bg={styles.bg}
      borderLeftWidth="3px"
      borderLeftColor={styles.border}
      borderRadius="md"
      px={4}
      py={3}
    >
      <HStack align="start" spacing={3}>
        <Icon as={styles.icon} color={styles.iconColor} boxSize={4} mt="2px" />
        <VStack align="stretch" spacing={1.5} flex={1}>
          {title && (
            <Text14 fontWeight="medium" color="content.primary">
              {title}
            </Text14>
          )}
          <Text14 color="content.secondary">
            {children}
          </Text14>
        </VStack>
      </HStack>
    </Box>
  );
}
